export const Languages: { value: string; label: string }[] = [
    {
        value: 'en',
        label: 'general.global_preferences.english',
    },
    {
        value: 'de',
        label: 'general.global_preferences.german',
    },
];
